<script setup lang="ts">
import { computed } from 'vue';
import { BLink } from 'bootstrap-vue-next';
import type { LinkTarget } from 'bootstrap-vue-next';
import type { IColumnDefinition, RowData, ILinkColumn } from '../types';

interface Props {
  value: any;
  row: RowData;
  column: IColumnDefinition;
}
const props = defineProps<Props>();

const col = computed(() => props.column as ILinkColumn);

const linkTo = computed<any>(() => {
  const to = col.value.to;
  if (typeof to === 'function') {
    return to(props.row);
  }
  return to;
});

const linkHref = computed<string | undefined>(() => {
  const href = col.value.href;
  if (typeof href === 'function') {
    return href(props.row);
  }
  return href;
});

const linkTarget = computed<LinkTarget | undefined>(
  () => col.value.target || '_self',
);
</script>

<template>
  <BLink
    :to="linkTo"
    :href="linkHref"
    :target="linkTarget"
    class="text-decoration-none text-primary d-inline-flex align-items-center gap-1"
    @click.stop="$emit('click', { row, column, value })"
  >
    {{ value }}
    <iconify-icon
      v-if="linkTarget === '_blank'"
      noobserver
      icon="mdi:open-in-new"
      style="font-size: 0.8em"
    />
  </BLink>
</template>
